module.exports = __webpack_public_path__ + "static/media/lahaye student union.a90e3e6a.jpeg";